<div class="custom-dropdown" (clickOutside)="model.open = false" *ngIf="items">
    <a class="selected-item" [ngClass]="{'open': model.open}" tabindex data-toggle="dropdown" aria-haspopup="true"
        aria-expanded="true" (click)="openItems()" fxFlex fxLayoutAlign="start center">
        <div class="thumb" [ngStyle]="{'background-color':  selectedItem?.color ? selectedItem?.color : '#000'}"
            fxFlex="34px" fxLayoutAlign="center center">{{model.firstLetter}}</div>
        <div class="description">
            <div class="label" *ngIf="selectedItem">{{selectedItem[this.display]}}</div>
        </div>
        <span class="mr-1" fxLayoutAlign="center center" *ngIf="selectedItem.status == 'N'">
            <mat-icon class="icon-problem ic-svg-yellow ic-20" svgIcon="icon_problem"></mat-icon>
        </span>
        <span class="select-partner-arrow" fxLayoutAlign="center center">
            <svg width="10" class="svg-inline--fa fa-chevron-down fa-w-14" role="img" aria-hidden="true"
                focusable="false" data-prefix="fas" data-icon="chevron-down" xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512">
                <path fill="currentColor"
                    d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z">
                </path>
            </svg>
        </span>
    </a>
    <div class="custom-dropdown-items" [ngClass]="{'show': model.open}">
        <div class="custom-dropdown-col" #dropdown>
          <!-- <a *ngFor="let item of items" (click)="changeItem(item)" [ngClass]="{'active': selectedItem == item}">{{item[this.display]}}</a> -->
          <div *ngFor="let item of items" class="action mb-2" fxFlex fxLayoutAlign="space-between center">
              <a fxFlex="100" fxLayoutAlign="start center" (click)="changeItem(item)"
                  [ngClass]="{'active': selectedItem == item }">
                  <mark [ngStyle]="{'background-color':  item?.color ? item?.color : '#000'}"></mark>
                  <span *ngIf="item">{{item[this.display]}}</span>
              </a>
              <div *ngIf="(user.isAdmin || user.isViewerOwner)" class="icon" fxFlex="auto" fxLayoutAlign="center center"
                  (click)="settingsItem(item)">
                  <mat-icon svgIcon="icon_gear" class="icon-gear"></mat-icon>
              </div>
          </div>
        </div>
        <ng-container *ngIf="can_add">
            <div class="action can-add mb-2" fxFlex fxLayoutAlign="space-between center">
                <a fxFlex="100" fxLayoutAlign="start center" (click)="addAccount()">
                    <mark style="background-color: #000"></mark>
                    <span class="add-new" fxFlex>{{ 'customDropdown.addNew' | translate}}</span>
                    <div class="icon" fxLayoutAlign="center center">
                        <mat-icon class="icon-add">add</mat-icon>
                    </div>
                </a>
            </div>
        </ng-container>
    </div>
</div>
